module.exports = __webpack_public_path__ + "img/angpao.de626052.png";